import { get } from 'Api';
import store from 'Redux/store';

export async function getFacet(facet, slug) {
  const language = window.locale || 'en';
  const url = `/facet/${facet}/${slug}/${language}`;
  return get(store.dispatch, url, true);
}

export async function getFacetRelated(facet, slug) {
  const language = window.locale || 'en';
  const url = `/facet/${facet}/${slug}/related/${language}`;
  return get(store.dispatch, url, true);
}

export async function getFacetReviews(facet, slug) {
  const language = window.locale || 'en';
  const url = `/facet-reviews/${facet}/${slug}/${language}`;
  return get(store.dispatch, url, true);
}

export async function getFacets(facet) {
  const language = window.locale || 'en';
  const url = `/facet/${facet}/all/${language}`;
  return get(store.dispatch, url, true);
}

let facetCache = [];

export async function getAllFacets() {
  if (facetCache && facetCache.length) {
    return facetCache;
  }

  const language = window.locale || 'en';
  const url = `/facet/all/${language}`;
  const { response, data } = await get(store.dispatch, url, true);
  if (response.status === 200) {
    facetCache = data;
    return data;
  }

  return Promise.resolve(facetCache);
}
